"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultQuoteToolContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DefaultQuoteToolContext = exports.DefaultQuoteToolContext = {
  layout: {
    bodyCssClass: 'quoteTool',
    main: {
      heading: {
        headingText: 'Your pet\'s details',
        headingSecondaryText: '',
        mandatoryText: 'Mandatory fields'
      }
    }
  }
};